import React from "react";
import { Color } from "../types/color.model";
import { shiftColorValue } from "../utils/color.utils";

interface TwistedStripePreviewProps {
    stripe1: Color;
    stripe2: Color;
    stripe3: Color;
    stripe4: Color;
    stripe5: Color;
}

const TwistedStripePreview: React.FC<TwistedStripePreviewProps> = ({ stripe1, stripe2, stripe3, stripe4, stripe5 }) => (
    <svg width="51" height="82" viewBox="0 0 51 82" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M51 0V12L27 0H51Z" fill={stripe1} stroke={shiftColorValue(stripe1, -30)} strokeWidth={0.5} />
        <path d="M0 14.5912V0L51 25.4088V40L0 14.5912Z" fill={stripe3} stroke={shiftColorValue(stripe3, -30)} strokeWidth={0.5} />
        <path d="M0 0.273585V-1H26.75L51 11.2264V26L0 0.273585Z" fill={stripe2} stroke={shiftColorValue(stripe2, -30)} strokeWidth={0.5} /> 
        <path d="M0 28.9473V14L51 39.3724V53L0 28.9473Z" fill={stripe4} stroke={shiftColorValue(stripe4, -30)} strokeWidth={0.5} /> 
        <path d="M0 42.0523V28.9453L51 52.9754V65L0 42.0523Z" fill={stripe5} stroke={shiftColorValue(stripe5, -30)} strokeWidth={0.5} /> 
        <path d="M51 82H41V60L51 64.6927V82Z" fill={stripe5} stroke={shiftColorValue(stripe5, -30)} strokeWidth={0.5} /> 
        <path d="M41 82H31V55L41 59.6437V82Z" fill={stripe4} stroke={shiftColorValue(stripe4, -30)} strokeWidth={0.5} /> 
        <path d="M31 82H20V50.225L31 55L31 82Z" fill={stripe3} stroke={shiftColorValue(stripe3, -30)} strokeWidth={0.5} /> 
        <path d="M19.901 82H10V45.73L20 50.23L19.901 82Z" fill={stripe2} stroke={shiftColorValue(stripe2, -30)} strokeWidth={0.5} /> 
        <path d="M10 82H0V41.16L10 45.73V82Z" fill={stripe1} stroke={shiftColorValue(stripe1, -30)} strokeWidth={0.5} /> 
    </svg>
);

export default TwistedStripePreview;
